// extracted by mini-css-extract-plugin
export default {"container":"Table_container__loKwK","row":"Table_row__DjXVH"};